module.exports = __webpack_public_path__ + "static/media/spanish-past-tense-table-5.0cc4722e.JPG";